export default __webpack_public_path__ + "static/SRUS LF410 - Product Specifications & Technical Data-cb119b3cbfdfdc762c24392a38a18e87.pdf";